module.exports = __webpack_public_path__ + "img/FR13489.220bd651.png";